import styled from "@emotion/native";
import {
    useSafeAreaFrame,
    useSafeAreaInsets,
} from "react-native-safe-area-context";
import { ViewStyle, Platform } from "react-native";
import Text from "../../components/Text";

export const Container = styled.ScrollView(
    {
        flex: 1,
        overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
        backgroundColor: "transparent",
    },
    ({ theme, isInterstitial }: any) => {
        const style: ViewStyle = {};

        if (isInterstitial) {
            style.backgroundColor = theme?.color?.interstitialBackground;
        }

        return style;
    },
);

Container.defaultProps = {
    contentContainerStyle: { flexGrow: 1 },
};

export const Main = styled.View(
    {
        flex: 1,
        paddingHorizontal: 22,
        // debug
        // borderColor: "red",
        // borderWidth: 1,
    },
    ({ theme }: any) => {
        const insets = useSafeAreaInsets();
        const paddingTop = 20;
        const paddingBottom = insets.bottom;

        return {
            paddingTop,
            paddingBottom,
        };
    },
);

export const Progress = styled(Text)({
    textAlign: "center",
    marginBottom: 17,
});

export const Body = styled(Text)({});

export const Caption = styled(Text)({
    marginTop: 20,
});

export const Options = styled.View(
    {
        marginTop: 38,
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    ({ isWide }: any) => {
        let style: ViewStyle = {};

        if (isWide) {
            style = {
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "stretch",
                flexWrap: "nowrap",
            };
        }

        return style;
    },
);

export const Option = styled.TouchableHighlight(
    {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
        marginBottom: 22,
        shadowColor: "#162928",
        ...Platform.select({
            ios: {
                shadowOffset: {
                    width: 0,
                    height: 2,
                },
            },
        }),
        shadowRadius: 4,
    },
    ({ theme, isSelected, isWide }: any) => {
        const frame = useSafeAreaFrame();
        const {
            color: { enabled, selected },
        } = theme;
        let lineHeight = 25;
        let padding = 11;
        let borderWidth = 5;
        let minHeight = lineHeight * 3 + padding * 2 + borderWidth * 2;
        const backgroundColor = isSelected ? selected : enabled;
        let style: ViewStyle = {
            backgroundColor,
            minHeight,
            padding,
        };

        if (!isWide) {
            style.width = frame.width * 0.42;
        }

        if (theme.verticalScale < 1) {
            const delta = 1 - theme.verticalScale;
            const verticalScale = 1 - delta / 2;

            padding = padding * verticalScale;
            minHeight = minHeight * verticalScale;

            style = {
                ...style,
                minHeight,
                padding,
            };
        }

        return style;
    },
);

export const __ = styled.TouchableHighlight({
    borderWidth: 10,
});

export const MultipleSelectOption = styled(Option)(
    {
        borderWidth: 5,
        opacity: 0.66,
    },
    ({ theme, isSelected }: any) => {
        return {
            borderColor: theme.color.enabled,
            backgroundColor: isSelected
                ? theme.color.activeMultipleSelectBackground
                : theme.color.inactiveMultipleSelectBackground,
            opacity: isSelected ? 1 : 0.66,
        };
    },
);
